import { Link, useLocation } from "react-router-dom";
import { Home, Briefcase, Calendar, Menu, CheckSquare } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface NavItem {
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  labelKey: string;
}

const BottomNav = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const navItems: NavItem[] = [
    { path: "/", icon: Home, labelKey: "nav.home" },
    { path: "/today-board", icon: CheckSquare, labelKey: "nav.today" },
    { path: "/jobs", icon: Briefcase, labelKey: "nav.jobs" },
    { path: "/schedule", icon: Calendar, labelKey: "nav.schedule" },
    { path: "/more", icon: Menu, labelKey: "nav.more" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-primary border-t border-primary z-50 shadow-lg md:hidden" data-tour="navigation">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
            (item.path !== "/" && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors",
                isActive
                  ? "text-secondary"
                  : "text-primary-foreground/70 hover:text-primary-foreground"
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs font-medium">{t(item.labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
